
const angular = require('angular')
const jquery = require('jquery')

angular.module('clientDashboardApp').directive('extraClickyMultiSelector', () => {

  return {
    restrict: 'A',
    require: 'ui-select',
    link: function(scope, element, attrs, select) {
      jquery(element).children('.select2-choices').on('click', function (event) {
        if (event.target === this) {
          scope.$apply(() => {
            select.activate()
          })
        }
      })
    }
  }
})
